import { getServerURL } from "../../helper/envConfig";
class CustomUploadAdapter {
    constructor(loader, setLoading) {
        this.loader = loader;
        this.setLoading = setLoading; // Store the setLoading function
    }

    upload() {
        return this.loader.file.then(file => new Promise((resolve, reject) => {
            this.setLoading(true); // Start loading

            // Allowed image types
            const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];

            // Check if the file type is allowed
            if (!allowedImageTypes.includes(file.type)) {
                alert(`Unsupported image type: ${file.type}`);
                this.setLoading(false); // Stop loading
                return reject(`Unsupported image type: ${file.type}`);
            }

            const formData = new FormData();
            formData.append('image', file);

            const uploadURL = `${getServerURL()}blog/image-upload/`;

            fetch(uploadURL, {
                method: 'POST',
                body: formData,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            })
            .then(response => {
                if (!response.ok) throw new Error('Upload failed');
                return response.json();
            })
            .then(result => {
                this.setLoading(false); // Stop loading
                resolve({
                    default: result.path // Assuming the server responds with the URL of the uploaded image
                });
            })
            .catch(error => {
                this.setLoading(false); // Stop loading on error
                reject(error);
            });
        }));
    }

    abort() {
        // Implementation for abort if necessary
    }
}

export default CustomUploadAdapter;
